import { render, staticRenderFns } from "./comp-restricted.vue?vue&type=template&id=20ef818e&"
import script from "./comp-restricted.vue?vue&type=script&lang=ts&"
export * from "./comp-restricted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports